import Vue from "vue";
import Component from "vue-class-component";
import SidebarComponent from "@/components/sidebar/sidebar.component.vue";
import HeaderComponent from "@/components/header/header.component.vue";
import LoaderComponent from "@/components/loader/loader.component.vue";
import ModalPermissionsComponent from '@/components/modal-permissions/modal-permissions.component.vue';
import ModalLoginComponent from '@/components/modal-login/modal-login.component.vue';

import RoleService from "@/core/services/role.service.ts";
import SidebarService from "@/core/services/sidebar.service.ts";

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    LoaderComponent
  }
})
export default class CreateRolesComponent extends Vue {
  roleService: any = new RoleService();
  sidebarService: any = new SidebarService();
  genericErr: any = [];
  isLoading: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  isSuccess: boolean = false;
  isErrorServer: boolean = false;
  modal: boolean = false;
  error: boolean = false;
  permissions: any = [];
  alias: string = "";
  company: string = "";
  modules: any = [
    {
      alias: "Acceso ilimitado",
      endpoint: "^/.*$"
    },
    {
      alias: "Empresa",
      endpoint: "^/company.*$"
    },
    {
      alias: "Giro",
      endpoint: "^/business.*$"
    },
    {
      alias: "Roles",
      endpoint: "^/role.*$"
    },
    {
      alias: "Administradores",
      endpoint: "^/user/admin.*$"
    },
    {
      alias: "Candidatos",
      endpoint: "^/user/candidate.*$"
    },
    {
      alias: "Preguntas",
      endpoint: "^/question.*$"
    },
    {
      alias: "Secciones",
      endpoint: "^/section.*$"
    },
    {
      alias: "Recursos",
      endpoint: "^/resource.*$"
    },
    {
      alias: "Competencias",
      endpoint: "^/skill.*$"
    },
    {
      alias: "Reporte",
      endpoint: "^/test/.*$"
    },
    {
      alias: "Perfiles",
      endpoint: "^/profile.*$"
    },
    {
      alias: "Soporte",
      endpoint: "^/support.*$"
    }
  ];

  mounted() {
    const _ = this;
  }

  closeSidebar() {
    const _ = this;
    _.sidebarService.close();
  }

  create() {
    const _ = this;
    let role = {
      alias: _.alias,
      company: _.company,
      permissions: _.modules
    };
    _.isLoading = true;
    _.roleService
      .create(role)
      .then((data: any) => {
        _.isSuccess = true;
        _.isErrorServer = false;
        _.error = false;
        _.modal = true;
        setTimeout(() => {
          _.isLoading = false;
          _.$router.push("/roles");
        }, 2000);
      })
      .catch((err: any) => {
        _.modal = true;
        _.error = true;
        _.isErrorServer = true;
        setTimeout(() => {
          _.isLoading = false;
        }, 2000);
      });
  }

  validations(alias = "") {
    const _ = this;
    _.genericErr = [];
    if (alias == "") {
      _.genericErr.push("Por favor introduce un alias");
    }
    if(_.genericErr.length > 0){
      _.modal = true;
      _.error = true;
      return;
    }
    _.create()
  }
}
